import React, { useState } from 'react';
import BookFormModal from './BookFormModal';
import FeedbackModerationModal from './FeedbackModerationModal';
import './BooksEditor.css';
import './AdminForm.css'; // Fontos: a közös stílusokat is importáljuk!

const BooksEditor = ({ books, feedbacks, onFormChange }) => {
  const [isBookModalOpen, setIsBookModalOpen] = useState(false);
  const [editingBook, setEditingBook] = useState(null);
  const [moderatingBook, setModeratingBook] = useState(null);

  const handleAddNew = () => {
    setEditingBook({
      id: `new-book-${Date.now()}`,
      title: "",
      isFeatured: false,
      tagline: "",
      description: "",
      coverImage: "",
      downloads: { 
        pdf: { url: "", count: 0 },
        epub: { url: "", count: 0 },
        mobi: { url: "", count: 0 }
      },
      radioTransmissions: [],
      praises: [],
    });
    setIsBookModalOpen(true);
  };

  const handleEdit = (book) => {
    setEditingBook(book);
    setIsBookModalOpen(true);
  };

  const handleDeleteBook = (bookId) => {
    if (!window.confirm("Biztosan törölni szeretnéd ezt a könyvet? Ez a művelet nem vonható vissza.")) {
      return;
    }
    const updatedBooks = books.filter(b => b.id !== bookId);
    onFormChange('books', updatedBooks);
  };

  const handleSaveBook = (bookData) => {
    const index = books.findIndex(b => b.id === bookData.id);
    let updatedBooks;
    if (index > -1) {
      updatedBooks = [...books];
      updatedBooks[index] = bookData;
    } else {
      updatedBooks = [...books, bookData];
    }
    onFormChange('books', updatedBooks);
    setIsBookModalOpen(false);
  };

  const handleModerate = (book) => {
    setModeratingBook(book);
  };

  const handleDeleteFeedback = (feedbackTimestamp) => {
    if (!window.confirm("Biztosan törölni szeretnéd ezt a visszajelzést?")) {
      return;
    }
    const updatedFeedbacks = feedbacks.filter(fb => fb.timestamp !== feedbackTimestamp);
    onFormChange('feedbacks', updatedFeedbacks);
  };

  return (
    <>
      <div className="toolbar">
        <button onClick={handleAddNew} className="add-new-button">Új Könyv Hozzáadása</button>
      </div>
      <div className="table-wrapper">
        <table className="books-table">
          <thead>
            <tr>
              <th>Borító</th>
              <th>Cím</th>
              <th>ID</th>
              <th>Kiemelt</th>
              <th>Visszajelzések</th>
              <th style={{textAlign: 'right'}}>Műveletek</th>
            </tr>
          </thead>
          <tbody>
            {(books || []).map(book => {
              const feedbackCount = (feedbacks || []).filter(fb => fb.bookId === book.id).length;
              return (
                <tr key={book.id}>
                  <td><img src={book.coverImage || 'https://via.placeholder.com/40x60'} alt={book.title} className="table-cover-preview" /></td>
                  <td>{book.title || '(Nincs cím)'}</td>
                  <td>{book.id}</td>
                  <td>{book.isFeatured ? '✓ Igen' : '✗ Nem'}</td>
                  <td>
                    <button onClick={() => handleModerate(book)} className="action-button moderate">
                      Kezelés ({feedbackCount})
                    </button>
                  </td>
                  <td className="actions-cell">
                    <button onClick={() => handleEdit(book)} className="action-button edit">Szerkesztés</button>
                    <button onClick={() => handleDeleteBook(book.id)} className="action-button delete">Törlés</button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {isBookModalOpen && (
        <BookFormModal
          book={editingBook}
          onSave={handleSaveBook}
          onClose={() => setIsBookModalOpen(false)}
        />
      )}

      {moderatingBook && (
        <FeedbackModerationModal
          book={moderatingBook}
          feedbacks={(feedbacks || []).filter(fb => fb.bookId === moderatingBook.id)}
          onClose={() => setModeratingBook(null)}
          onDelete={handleDeleteFeedback}
        />
      )}
    </>
  );
};

export default BooksEditor;